// extracted by mini-css-extract-plugin
module.exports = {"wrap":"DealDetails_wrap__146xh","container":"DealDetails_container__EDFf7"};